var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_10674_11129)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    rx: 12.5,
    transform: "matrix(-1 0 0 1 26 0.5)",
    fill: "#E1FFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 4.5C16.5843 4.5 19.5 7.14677 19.5 10.3998C19.5 13.531 13.6027 20.8468 13.3516 21.1566L13.1172 21.4461C13.0898 21.4801 13.0462 21.5 13.0003 21.5C12.9537 21.5 12.9103 21.4801 12.8826 21.4461L12.6484 21.1566C12.3972 20.8468 6.5 13.531 6.5 10.3998C6.5 7.14677 9.41621 4.5 13.0003 4.5ZM13.0003 8.28647C11.7161 8.28647 10.6719 9.23427 10.6719 10.3998C10.6719 11.5646 11.7162 12.513 13.0003 12.513C14.2837 12.513 15.3287 11.5646 15.3287 10.3998C15.3287 9.23427 14.2837 8.28647 13.0003 8.28647Z",
    fill: "#89D624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_10674_11129",
    x: 0,
    y: 0.5,
    width: 26,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196693 0 0 0 0 0.668012 0 0 0 0 0.330233 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10674_11129"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLocation);
export default __webpack_public_path__ + "static/media/storeLocation.82787d165f322f332ec8ba4f568ca906.svg";
export { ForwardRef as ReactComponent };